import React from "react";
import { Button } from "@material-ui/core";
import { FcHighPriority } from "react-icons/fc";

import "./GenericError.scss";

export default function GenericError({ onGoBackClick = (event) => {}, ...props }) {
	const render = () => {
		return (
			<div className="GenericError">
				<FcHighPriority />
				<h3>Error Encountered</h3>
				<div>Please try again or contact us for further assistance.</div>
				<Button
					variant="contained"
					onClick={() => {
						onGoBackClick();
					}}
				>
					Back
				</Button>
			</div>
		);
	};
	return render();
}
